<template>
  <div class="maccontainer _maccontainer">
    <div class="newStyle flex">
      <div v-for="(item, index) in newStyle" :key="item.id" :class="{ 'active': menuIndex === index }"
        @click="changeMenu(index)">
        <img :src="item.img" alt="">
        <p class="hover-06c">{{ item.name }}</p>
        <p class="color-ff6b00">{{ item.title }}</p>
      </div>
    </div>
    <div class="color-f5f5f6 bgHeight"></div>
    <div class="doorList">
      <div class="line" v-for="(item, index) in newStyle[menuIndex].listImg" :key="item.id">
        <img :src="item.imgLink" alt="">
        <div class="option flex" v-if="item.understand" @click="toPages">
          <p class="understand">进一步了解</p>
          <div class="arrow">></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'luxuryArmourDoor',
  data() {
    return {
      menuIndex: 0,
      newStyle: [
        {
          id: 1,
          name: '尊奢装甲门系列',
          title: '新款',
          img: require('../../assets/luxuryArmourDoor/newStyle.png'),
          listImg: [
            {
              id: 1,
              imgLink: require('../../assets/luxuryArmourDoor/luxuryArmourDoor1.jpg'),
              understand: true,
            },
            {
              id: 2,
              imgLink: require('../../assets/luxuryArmourDoor/luxuryArmourDoor2.jpg'),
              understand: false,
            },
            {
              id: 3,
              imgLink: require('../../assets/luxuryArmourDoor/luxuryArmourDoor3.jpg'),
              understand: false,
            },
            {
              id: 4,
              imgLink: require('../../assets/luxuryArmourDoor/luxuryArmourDoor4.jpg'),
              understand: false,
            },
            {
              id: 5,
              imgLink: require('../../assets/luxuryArmourDoor/luxuryArmourDoor5.jpg'),
              understand: false,
            },
            {
              id: 6,
              imgLink: require('../../assets/luxuryArmourDoor/luxuryArmourDoor6.jpg'),
              understand: false,
            },
          ]
        },
        {
          id: 2,
          name: '尊奢装甲门国潮系列',
          title: '新款',
          img: require('../../assets/luxuryArmourDoor/newStyle.png'),
        },
        {
          id: 3,
          name: '尊奢装甲门国风系列',
          title: '新款',
          img: require('../../assets/luxuryArmourDoor/newStyle.png'),
          listImg: [
            {
              id: 1,
              imgLink: require('../../assets/door-gf/door-gf1.jpg'),
              understand: true,
            },
            {
              id: 2,
              imgLink: require('../../assets/door-gf/door-gf2.jpg'),
              understand: false,
            },
            {
              id: 3,
              imgLink: require('../../assets/door-gf/door-gf3.jpg'),
              understand: false,
            },
            {
              id: 4,
              imgLink: require('../../assets/door-gf/door-gf4.jpg'),
              understand: false,
            },
            {
              id: 5,
              imgLink: require('../../assets/door-gf/door-gf5.jpg'),
              understand: false,
            },
            {
              id: 6,
              imgLink: require('../../assets/door-gf/door-gf6.jpg'),
              understand: false,
            },
            {
              id: 7,
              imgLink: require('../../assets/door-gf/door-gf7.jpg'),
              understand: false,
            },
          ]
        },
        {
          id: 4,
          name: '尊奢装甲门青春系列',
          title: '新款',
          img: require('../../assets/luxuryArmourDoor/newStyle.png'),
          listImg: [
            {
              id: 1,
              imgLink: require('../../assets/door-youth/door-youth1.jpg'),
              understand: true,
            },
            {
              id: 2,
              imgLink: require('../../assets/door-youth/door-youth2.jpg'),
              understand: false,
            },
            {
              id: 3,
              imgLink: require('../../assets/door-youth/door-youth3.jpg'),
              understand: false,
            },
            {
              id: 4,
              imgLink: require('../../assets/door-youth/door-youth4.jpg'),
              understand: false,
            },
            {
              id: 5,
              imgLink: require('../../assets/door-youth/door-youth5.jpg'),
              understand: false,
            },
            {
              id: 6,
              imgLink: require('../../assets/door-youth/door-youth6.jpg'),
              understand: false,
            },
            {
              id: 7,
              imgLink: require('../../assets/door-youth/door-youth7.jpg'),
              understand: false,
            },
          ]
        },
      ]
    }
  },
  methods: {
    toPages() {
      window.location.href = 'http://192.168.110.158:8080/pdm/#/index?productId=15935'
    },
    changeMenu(index) {
      this.menuIndex = index
    }
  }
}
</script>

<style lang="less" scoped>
.color-ff6b00 {
  color: #ff6b00;
}

.color-f5f5f6 {
  background-color: #f5f5f6;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.newStyle {
  width: 1080px;
  margin: 0 auto;
  display: flex;

  &>div {
    flex: 1;
    padding-bottom: 15px;
    cursor: pointer;

    img {
      width: 90px;
      height: auto;
    }
  }

  &>div:hover {
    .hover-06c {
      color: #06c;
    }
  }

  &>div.active {
    .hover-06c {
      color: #06c;
    }
  }

  &>div:last-child {
    margin: 0;
  }
}

.bgHeight {
  height: 50px;
}

.doorList {
  .line {
    width: 100%;
    border-bottom: 7px solid #f5f5f6;

    img {
      width: 740px;
      height: auto;
    }

    .option {
      color: #0071e3;
      margin-bottom: 15px;
      cursor: pointer;
      flex-direction: column;

      .understand {
        font-size: 16px;
      }

      .arrow {
        width: 20px;
        height: 20px;
        font-size: 18px;
        margin-top: 9px;
        transform: rotate(90deg);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Home/Home.vue